module.exports = __webpack_public_path__ + "img/OnlineExpo_like.23f2f70a.png";